export default __webpack_public_path__ + "static/media/1782.da49223d.png";